module.exports = __webpack_public_path__ + "static/stawowa-residence-39ba10de3aed295ac5f90c68fda9ecbb.png";